import { doMutation } from "../../core-module/util/graphqlHelper";

export const createOrUpdateSubRole = input => {
  const mutation = require("../api/mutation/createOrUpdateSubRole.gql");
  const variables = { input };

  return doMutation({ mutation, variables }).then(({ data, error }) => {
    if (data) return { data: data.createOrUpdateSubRole };
    else if (error) return { error: JSON.stringify(error) };
  });
};
